import r from './rights'

const rightsList = [{
    id: 0,
    value: r.REFUND,
    label: "Возврат"
  },
  {
    id: 1,
    value: r.UNBLOCK,
    label: "Разблокирование"
  },
  {
    id: 2,
    value: r.CHARGE,
    label: "Списание"
  },
  {
    id: 3,
    value: r.AUTHORIZE,
    label: "Авторизация"
  },
  {
    id: 4,
    value: r.ANTIFRAUD_RULES_VIEW,
    label: "Просмотр правил антифрода"
  },
  {
    id: 5,
    value: r.GEN_PAY_LINK,
    label: "Генерация ссылки на оплату"
  },
  {
    id: 6,
    value: r.ANALYTIC,
    label: "Аналитика"
  },
  {
    id: 7,
    value: r.REPORTS,
    label: "Отчетность"
  },
  {
    id: 8,
    value: r.GEN_CSR,
    label: "Генерация CSR AP"
  },
  {
    id: 9,
    value: r.SHOW_BANK_LOGS,
    label: "Просмотр логов Банка"
  },
  {
    id: 10,
    value: r.ACTUALIZE_TRANSACTION_STATE,
    label: "Актуализация статуса транзакции"
  },
  {
    id: 11,
    value: r.FINANCE,
    label: "Финансы"
  }
]

export default rightsList